module.exports = __webpack_public_path__ + "static/media/walter.c10011ce.jpeg";